export default "__VITE_ASSET__0eb5e850__"